document.body.addEventListener('click', function(event) {
    if (event.target.classList.contains('wp-block-heading') || event.target.closest('.wp-block-heading')) {
        const el = event.target.classList.contains('wp-block-heading') ? event.target : event.target.closest('.wp-block-heading');

        const target = el.parentElement.querySelector('.wp-block-woocommerce-attribute-filter') ?? el.parentElement.querySelector('.wp-block-woocommerce-price-filter');
        const target2 = el.parentElement;

        target2.classList.toggle('active');

        if (target) {
            target.style.display = target2.classList.contains('active') ? 'block' : 'none';
        }
    }
});

if (document.querySelector('.axil-shop-sidebar')) {
    const checkExistence = setInterval(() => {
        if (document.querySelector('.wc-blocks-filter-wrapper')) {
            clearInterval(checkExistence);

            document.querySelectorAll('.wc-blocks-filter-wrapper').forEach(item => item.classList.add('active'));
        }
    }, 500);
}

document.querySelector('.filters__button')?.addEventListener('click', function () {
    document.querySelector('.shop-filter').classList.add('active');
});

document.querySelectorAll('.shop-filter__backdrop, .shop-filter__close').forEach(item => item.addEventListener('click', function () {
    const parent_el = this.closest('.shop-filter');
    parent_el.classList.remove('active');
}));